import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import rehypeHighlight from 'rehype-highlight';
import rehypeRaw from 'rehype-raw';
import 'highlight.js/styles/atom-one-dark.css';
import hljs from 'highlight.js';
import './styles/stylesidebar.css'
import SidebarInf04 from './components/sidebar/SidebarInf04';


const components = {
    codegroup: ({ node, ...props }) => <CodeGroup {...props} />,
    codegroupitem: ({ node, ...props }) => <CodeGroupItem {...props} title={props.title} />,
  };

const Rozwiazanieczworka = () => {
    const { klasyfikacja, rok, examId } = useParams();
    const [content, setContent] = useState('');

    const url = `https://raw.githubusercontent.com/PumaYT22/EgzaminyZawodoweINF/main/Egzaminy/INF04/${rok}/${examId}/rozwiazanie/rozwiazanie.md`;
    const btnurl = `https://github.com/PumaYT22/EgzaminyZawodoweINF/tree/main/Egzaminy/INF04/${rok}/${examId}/rozwiazanie/plikizrozwiazaniem`;

    useEffect(() => {
        fetch(url)
            .then(response => response.text())
            .then(data => setContent(data))
            .catch(error => console.error('Error fetching the markdown file:', error));

        
    }, [url]);

    useEffect(() => {
        hljs.addPlugin({
            'after:highlightElement': ({ result, el }) => {
                const lines = document.createElement('div');
                if (!result.value.includes('<span class="line-num">')) {
                    lines.innerHTML = result.value.replace(/^/gm, '<span class="line-num"></span>');
                }
                el.replaceChildren(...lines.childNodes);
            }
        });
      
        hljs.highlightAll();
       
    }, [content]);

    const goToView = (klasyfikacja, rok, examId) => {
        const url = `#/podgladinf04/${klasyfikacja}/${rok}/${examId}`;
        window.open(url, '_blank');
    };

    const downloadExam = (klasyfikacja, id, rok) => {
        const repoOwner = 'PumaYT22';
        const repoName = 'EgzaminyZawodoweINF';
        const branch = 'tree/main/';
        const folderPath = `Egzaminy/INF04/${rok}/${id}/arkusz`;

        const gitzipUrl = `https://kinolien.github.io/gitzip/?download=${repoOwner}/${repoName}/${branch}/${folderPath}`;

        window.open(gitzipUrl, '_blank');
    };

    return (
      <div id='rozwiazaniainf03'>

      <SidebarInf04></SidebarInf04>

      <div id="rozwiazanieustawienie">
        <div id="rozwiazanie" style={{ padding: '20px', maxWidth: '900px', margin: 'auto', textAlign: "left" }}>
            <button className="btn btn-danger" style={{ margin: "10px" }} onClick={() => goToView(klasyfikacja, rok, examId)}> Podgląd Arkusza pdf</button>
            <button style={{ margin: "10px" }} className="btn btn-outline-light" onClick={() => downloadExam(klasyfikacja, examId,rok)}>Pobierz Arkusz</button>
            <a href={btnurl} target='_blank' rel="noreferrer" style={{ margin: "10px" }}><button className='btn btn-primary'>Pobierz rozwiązanie - Github</button></a>
   
            {/* <div style={{ padding: '20px', maxWidth: '900px', margin: 'auto' }}>
      
                <CodeGroup>
                    <CodeGroupItem title="kwerendy1.txt">
                    <pre>
                        {`kw1: SELECT id, nazwa, wystepowanie FROM Ryby WHERE styl_zycia = 1;
            kw2: SELECT Ryby_id, wymiar_ochronny FROM Okres_ochronny WHERE wymiar_ochronny < 30;
            kw3: SELECT nazwa, akwen, wojewodztwo FROM Ryby INNER JOIN Lowisko ON Ryby.id = Lowisko.Ryby_id WHERE rodzaj = 3;
            kw4: ALTER TABLE Ryby ADD dobowy_limit TINYINT UNSIGNED;`}
                    </pre>
                    </CodeGroupItem>
                    <CodeGroupItem title="kwerendy2.txt">
                    <pre>
                        {`kw1: SELECT id, nazwa, wystepowanie FROM Ryby WHERE styl_zycia = 1;
            `}
                    </pre>
                    </CodeGroupItem>
                    <CodeGroupItem title="kwerendy3.txt">
                    <pre>
                        {`kw1: SELECT id, nazwa, wystepowanie FROM Ryby WHERE styl_zycia = 1;
            kw2: SELECT Ryby_id, wymiar_ochronny FROM Okres_ochronny WHERE wymiar_ochronny < 30;
            kw3: SELECT nazwa, akwen, wojewodztwo FROM Ryby INNER JOIN Lowisko ON Ryby.id = Lowisko.Ryby_id WHERE rodzaj = 3;
            kw4: ALTER TABLE Ryby ADD dobowy_limit TINYINT UNSIGNED;`}
                    </pre>
                    </CodeGroupItem>
                </CodeGroup>
                </div> */}


            <ReactMarkdown components={components} rehypePlugins={[rehypeHighlight, rehypeRaw]}>
                {content}
            </ReactMarkdown>
        </div>
      </div>
    </div>
    );
};


const CodeGroup = ({ children }) => {
    const [activeIndex, setActiveIndex] = useState(0);
  
    // Ustawienie pierwszego taba z tytułem jako aktywny na starcie
    useEffect(() => {
      const firstIndexWithValidTitle = React.Children.toArray(children).findIndex(
        child => child.props && child.props.title
      );
      if (firstIndexWithValidTitle !== -1) {
        setActiveIndex(firstIndexWithValidTitle);
      }
  
      
       
    }, [children]);
  
  
    return (
      <div className="code-group">
        <div className="code-group-tabs">
          {React.Children.map(children, (child, index) => {
            if (!child.props || !child.props.title) return null;
  
            return (
              <button
                key={index}
                className={`code-group-tab ${activeIndex === index ? 'active' : ''}`}
                onClick={() => setActiveIndex(index)}
              >
                {child.props.title}
              </button>
            );
          })}
        </div>
        <div className="code-group-content">
          {React.Children.toArray(children)[activeIndex]}
        </div>
      </div>
    );
  };
  
  const CodeGroupItem = ({ title,children }) => {
    return <div className="code-group-item">{children}</div>;
  };

export default Rozwiazanieczworka;

